import { ethers, Contract } from "ethers";
import { staticProvider } from "../config/configContracts";

export const getTokenBalance = async (
  tokenAddress: string,
  userAddress: string,
  decimals: number = 18
): Promise<string> => {
  try {
    // Validate addresses
    if (!ethers.isAddress(tokenAddress)) {
      throw new Error(`❌ Invalid token address: ${tokenAddress}`);
    }
    if (!ethers.isAddress(userAddress)) {
      throw new Error(`❌ Invalid user address: ${userAddress}`);
    }

    // Ensure the contract exists at the token address
    const code = await staticProvider.getCode(tokenAddress);
    if (code === "0x") {
      throw new Error(`❌ ${tokenAddress} is not a contract address.`);
    }

    // Create minimal ERC-20 contract instance for balanceOf
    const tokenContract = new Contract(
      tokenAddress,
      ["function balanceOf(address) view returns (uint256)"],
      staticProvider
    );

    // Query raw balance and format according to decimals
    const balance = await tokenContract.balanceOf(userAddress);
    return ethers.formatUnits(balance, decimals);
  } catch (error) {
    // Log and return zero on any failure
    console.error(
      "❌ Error while fetching token balance:",
      error instanceof Error ? error.message : error
    );
    return "0";
  }
};
